
export * from '../../fragment-renderer-collection-filter-impl/__liferay__/index.js';
